import angular from 'angular';
import uiRouter from 'angular-ui-router';
import authenticationComponent from './authentication.component';

let authenticationModule = angular.module('authentication', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('login', {
      url: '/login',
      template: '<authentication></authentication>',
      authenticate: true
    })
})

.component('authentication', authenticationComponent);

export default authenticationModule;



// WEBPACK FOOTER //
// ./client/app/components/authentication/authentication.js